import * as types from "./types";

const defaultState = {
    popupList: [],
    videoList: [],
    popupTable: {
        tableHeaders: [
            "Title",
            "Description",
            "Start",
            "End",
            "Actions"
        ],
        tableColumns: [
            "title",
            "message",
            "startDate",
            "endDate"
        ]
    },
    videoTable: {
        tableHeaders: [
            "Title",
            "Description",
            "Status",
            "All Star Game",
            "Date and Time",
            "Actions"
        ],
        tableColumns: [
            "videoTitle",
            "videoDescription",
            "isLive",
            "isAllStarGame",
            "dateTime"
        ]
    },
    popupForm:{
        model: "PopupModel",
        form:[
            {
                type: "text",
                label: "Announcement Title",
                placeholder: "Enter announcement title",
                name: "title",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: "editor",
                label: "Announcement Description",
                name: "message",
                required: true,
                default: '',
                md: 12,
                xs: 12
            },
            {
                type: "dateTimeRange", //data will be start date and end date
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 255
            }
        ]
    },
    bannerForm: {
        model: "BannerModel",
        form: [
            {
                type: "text",
                label: "Announcement Title",
                placeholder: "Enter announcement title",
                name: "title",
                default: '',
                required: true,
                md: 6,
                xs: 12,
                maxLength: 125
            },
            {
                type: "dateRange", //data will be start date and end date
                required: true,
                default: '',
                md: 6,
                xs: 12,
                maxLength: 255
            },
            {
                type: "editor",
                label: "Announcement Description",
                name: "message",
                required: true,
                default: '',
                md: 10,
                xs: 12
            },
            {
                type: "line"
            },
            {
                type: "text",
                label: "Default Title",
                name: "announcementTitle",
                placeholder: "Enter default announcement title",
                default: '',
                required: true,
                md: 6,
                xs: 12,
                maxLength: 125
            },
            {
                type: "editor_two",
                label: "Default Description",
                name: "announcementMessage",
                required: true,
                default: '',
                md: 10,
                xs: 12
            },
        ]
    },
    videoForm:{
        model: "VideoModel",
        form:[
            {
                type: "text",
                label: "Video Title",
                placeholder: "Enter video title",
                name: "videoTitle",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: "textarea",
                label: "Video Description",
                name: "videoDescription",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 255
            },
            {
                type: "text",
                label: "Youtube ID",
                placeholder: "Enter youtube id",
                name: "youtubeId",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: "text",
                label: "Game Type",
                placeholder: "Enter game type",
                name: "gameType",
                default: '',
                required: true,
                md: 12,
                xs: 12,
                maxLength: 125
            },
            {
                type: "checkbox",
                label: "Live",
                name: "isLive",
                default: false,
                md: 2,
                xs: 12,
                inline: true
            },
            {
                type: "checkbox",
                label: "All Star",
                name: "isAllStarGame",
                default: false,
                md: 2,
                xs: 12,
                inline: true
            },
            {
                type: "datepicker", //data will be start date and end date
                required: true,
                md: 12,
                xs: 12,
                name: 'dateTime',
                label: "Date and Time"
            },
        ]
    },
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.SET_POPUP_LIST:
            return { ...state, popupList: action.payload};
        case types.SET_VIDEO_LIST:
            return { ...state, videoList: action.payload};
        default: return state;
    }
};